//eslint-disable-next-line no-unused-vars
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from '@gisatcz/ptr-state';
import {getWebInstrumentations, initializeFaro} from '@grafana/faro-web-sdk';
import {TracingInstrumentation} from '@grafana/faro-web-tracing';

import createStore from './state/Store';
import {AppWrapper} from './app';
import AppTour from './components/Tour';
import config from './config';

const {store} = createStore();

const Application = () => (
	<Provider store={store}>
		<AppTour>
			<AppWrapper />
		</AppTour>
	</Provider>
);

initializeFaro({
	url: config.faroUrl,
	app: {
		name: 'app-esaWorldWater',
		version: '1.0.0',
		environment: 'production',
	},

	instrumentations: [
		// Mandatory, omits default instrumentations otherwise.
		...getWebInstrumentations(),

		// Tracing package to get end-to-end visibility for HTTP requests.
		new TracingInstrumentation(),
	],
});

function renderApp() {
	const container = document.getElementById('root');
	const root = createRoot(container); // createRoot(container!) if you use TypeScript
	root.render(<Application />);
}

renderApp();
